export interface AffiliatePlatform {
  id: string;
  name: string;
  /** Short label under the name, e.g. "Social casino". */
  category: string;
  description: string;
  /** Marketing bullets shown on the card. */
  offers: string[];
  /** Public site, if the platform has one we can link to. */
  website?: string;
  /** Affiliate/promo code issued with the LaunchPad, if already assigned. */
  code?: string;
  /** Shown when no code is published yet. */
  codeNote: string;
  image?: string;
  imageAlt?: string;
  accent: 'brand' | 'gold' | 'accent';
}

/**
 * Licensed platforms we market on behalf of. Each LaunchPad ships with the
 * operator's affiliate code for these platforms already configured.
 */
export const AFFILIATE_PLATFORMS: AffiliatePlatform[] = [
  {
    id: 'legacy-arcade',
    name: 'Legacy Social Casino',
    category: 'Social casino · legacyarcade.com',
    description:
      'Fish games, slots, live dealers, casual and table games with instant redemption. Legacy is our flagship partner and the platform most LaunchPads run out of the box.',
    offers: [
      '300% welcome bonus — buy 10, get 30 free Sweeps + 40K Gold',
      'Free 2 Sweeps + 30K Gold, no purchase necessary',
      'Visa, Mastercard, Apple Pay, Skrill, AMEX and bank transfer',
      'Weekly residual commissions on qualified player activity',
    ],
    website: 'https://legacyarcade.com',
    codeNote: 'Your unique Legacy affiliate code is issued with your LaunchPad.',
    image: '/images/legacy-social-casino.jpg',
    imageAlt: 'Legacy Social Casino new player bonus promotion',
    accent: 'brand',
  },
  {
    id: 'ruby-sweeps',
    name: 'Ruby Sweeps',
    category: 'Sweepstakes platform',
    description:
      'A sweepstakes gaming platform available to LaunchPad operators. Run Ruby Sweeps promotions on your screens and earn on every player you introduce.',
    offers: [
      'Dedicated Ruby Sweeps advertising creative for your screens',
      'Affiliate code issued per location',
      'Player signups tracked back to your venue',
      'Commissions paid on qualified activity',
    ],
    codeNote: 'Request your Ruby Sweeps affiliate code — issued on approval.',
    accent: 'gold',
  },
  {
    id: 'lucky-lake',
    name: 'Lucky Lake',
    category: 'Social casino',
    description:
      'Lucky Lake rounds out the lineup for operators who want to rotate more than one brand across their LaunchPad screens and compare which converts best in their venue.',
    offers: [
      'Lucky Lake affiliate code for your location',
      'Rotate alongside Legacy and Ruby Sweeps on the same device',
      'Per-brand performance visible in your dashboard',
      'Commissions paid on qualified activity',
    ],
    codeNote: 'Request your Lucky Lake affiliate code — issued on approval.',
    accent: 'accent',
  },
];
